module.exports = __webpack_public_path__ + "img/sindicato.9957e573.png";